import classNames from "classnames";
import styles from "./Link.module.css";
import { PropsWithChildren } from "react";

type LinkProps = {
  id?: string;
  to?: string;
  title?: string;
  target?: string;
  className?: string;
};

export const Link = (props: PropsWithChildren<LinkProps>) => {
  const { to, title = "", target = "_self", children, className = "", id } = props;

  const linkClassNames = classNames(styles.link, className);

  return (
    <a id={id} className={linkClassNames} href={to} target={target} title={title}>
      {children}
    </a>
  );
};
